module.exports = __webpack_public_path__ + "static/media/comparison.df75ea5c.svg";